import { useContext, useState } from "react";
import { convert } from "html-to-text";
import dayjs from "dayjs";
import OsteopataContext from "../../context/osteopata";
import AppError from "../app-error";
import Title from "../title";
import OsteopataCancelAppointmentModal from "./osteopata-cancel-appointment-modal";
import OsteopataDetail from "./osteopata-detail";
import OsteopataDiscardRequestModal from "./osteopata-discard-request-modal";
import OsteopataRecap from "./osteopata-recap";
import OsteopataRequests from "./osteopata-requests";
import OsteopataSurvey from "./osteopata-survey";
import Toast from "../toast";

const OsteopataBody = () => {
  const {
    survey,
    error,
    isFetching,
    labels,
    appLang,
    currentRequest,
    navigation,
    osteopataInfo,
    setNavigation,
    setCurrentRequest,
  } = useContext(OsteopataContext);

  const [discardModal, setDiscardModal] = useState(false);
  const [cancelledToast, setCancelledToast] = useState();
  const [cancelAppointmentModal, setCancelAppointmentModal] = useState();

  return error ? (
    <AppError labels={labels} />
  ) : isFetching ? (
    <div className="loading-spinner mt" />
  ) : (
    <>
      <Title
        description={
          !navigation &&
          !currentRequest &&
          (
            labels?.WELFARE_OSTEOPATA_BOOKING_DESCRIPTION_BANNER ||
            "Potrai effettuare all'interno della sede di <strong>[LOCATION]</strong>"
          ).replace("[LOCATION]", convert(survey?.description))
        }
        button={
          navigation
            ? []
            : currentRequest
            ? []
            : [
                ...(osteopataInfo
                  ? [
                      {
                        action: () => setNavigation("info"),
                        label: labels?.WELFARE_OSTEOPATA_BOOKING_READ_MORE || "Scopri di più",
                        icon: "angle-down",
                        link: true,
                      },
                    ]
                  : []),
                {
                  action: () => {
                    setCurrentRequest("new");
                  },
                  label: labels?.WELFARE_OSTEOPATA_BOOKING_CTA || "Prenota",
                  className: "button app__title-button",
                },
              ]
        }
        handleNavigation={
          navigation === "info"
            ? () => setNavigation(null)
            : currentRequest
            ? currentRequest === "new"
              ? () => setDiscardModal(true)
              : () => setCurrentRequest()
            : null
        }
        handleSticky={true}
      >
        {navigation === "info"
          ? osteopataInfo?.title || "Osteopata"
          : currentRequest
          ? currentRequest === "new" || currentRequest?.status === "DRAFT"
            ? labels?.WELFARE_OSTEOPATA_BOOK_TITLE_BANNER || "Prenota visita"
            : (
                labels?.WELFARE_OSTEOPATA_BOOKED_TITLE_BANNER ||
                "Prenotazione [OSTEOPATA] del [DATE]"
              )
                .replace("[OSTEOPATA]", `${currentRequest?.osteopath?.name || ""}`)
                .replace(
                  "[DATE]",
                  dayjs(Number(currentRequest?.bookingDate))
                    .locale(appLang?.value || "it")
                    .format("LL")
                )
          : labels?.WELFARE_OSTEOPATA_OPEN_TITLE_BANNER ||
            "Migliora il tuo benessere, prenota una visita osteopatica"}
      </Title>
      {navigation === "info" ? (
        <OsteopataDetail data={osteopataInfo} />
      ) : currentRequest ? (
        currentRequest === "new" || currentRequest?.editMode ? (
          <OsteopataSurvey />
        ) : (
          <OsteopataRecap setCancelAppointmentModal={setCancelAppointmentModal} />
        )
      ) : (
        <div className="wrapper wrapper--app">
          <OsteopataRequests setCancelAppointmentModal={setCancelAppointmentModal} />
          <OsteopataRequests past={true} />
        </div>
      )}
      <OsteopataDiscardRequestModal
        key={`discard-${!!discardModal}`}
        discardModal={discardModal}
        setDiscardModal={setDiscardModal}
      />
      <OsteopataCancelAppointmentModal
        key={`cancel-${!!cancelAppointmentModal}`}
        modal={cancelAppointmentModal}
        setModal={setCancelAppointmentModal}
        request={cancelAppointmentModal}
        setCancelledToast={setCancelledToast}
      />
      {!!cancelledToast && (
        <Toast
          message={(
            labels?.WELFARE_OSTEOPATA_CANCELLED_TOAST_MESSAGE ||
            "Il tuo appuntamento del [DATE] è stato correttamente disdetto"
          ).replace(
            "[DATE]",
            dayjs(Number(cancelledToast.bookingDate))
              .locale(appLang?.value || "it")
              .format("LL")
          )}
          setToastVisibility={setCancelledToast}
        />
      )}
    </>
  );
};

export default OsteopataBody;
